import React from 'react';
import Icon from 'components/general/icon/icon';
import { Application } from '../../../__models__/models';
import { formatEorCandidateNames } from '../eor_utils';

const styles = require('./EorBanner.module.scss');

interface EorBannerProps {
  qualifyingCandidates: Application[];
}

export default function EorBanner({ qualifyingCandidates }: EorBannerProps) {
  if (qualifyingCandidates.length === 0) return null;

  const names = formatEorCandidateNames(qualifyingCandidates);

  const handleCalculateClick = () => {
    document.dispatchEvent(new Event('eor-calculator:open'));
  };

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <span className={styles.globe}>
          <Icon name='globe' />
        </span>
        <p className={styles.text}>
          {names} may require work authorization. Employer of Record (EOR) can help.
        </p>
        <button type="button" className={styles.cta} onClick={handleCalculateClick}>
          Calculate EOR cost
        </button>
      </div>
    </div>
  );
}
